import { API_URL } from "../config";

const getAuthHeaders = () => {
  const token = JSON.parse(localStorage.getItem("authToken"));
  return {
    Authorization: `Bearer ${token?.access}`,
    "Content-Type": "application/json",
  };
};

// SAFE FETCH (prevents crash)
const safeFetch = async (url) => {
  const res = await fetch(url, { headers: getAuthHeaders() });

  if (!res.ok) {
    const text = await res.text();
    console.error("API ERROR:", url, text);
    throw new Error("Request failed");
  }

  return res.json();
};

// GLOBAL ANALYSIS
export const fetchGlobalAnalysis = (term, session) => {
  let url = `${API_URL}/analysis/global/`;

  const params = new URLSearchParams();
  if (term) params.append("term", term);
  if (session) params.append("session", session);

  return safeFetch(`${url}?${params.toString()}`);
};

// CLASS
export const fetchClassAnalysis = (id, term, session) => {
  return safeFetch(
    `${API_URL}/analysis/class/${id}/?term=${term || ""}&session=${
      session || ""
    }`
  );
};

// SUBJECT
export const fetchSubjectAnalysis = (id, term, session) => {
  return safeFetch(
    `${API_URL}/analysis/subject/${id}/?term=${term || ""}&session=${
      session || ""
    }`
  );
};

// STUDENT
export const fetchStudentAnalysis = (id, term, session) => {
  return safeFetch(
    `${API_URL}/analysis/student/${id}/?term=${term || ""}&session=${
      session || ""
    }`
  );
};



export const fetchSessions = async () => {
  const res = await fetch(`${API_URL}/sessions/`, {
    headers: getAuthHeaders(),
  });

  return res.json();
};


// ✅ GET STUDENTS BY CLASS
export const getStudentsByClass = async (classId) => {
  return safeFetch(`${API_URL}/instclass/${classId}/students/`);
};

// ✅ GET SUBJECTS BY CLASS
export const getSubjectsByClass = async (classId) => {
  return safeFetch(`${API_URL}/instclass/${classId}/subjects/`);
};